import React from 'react';
import i18n from 'i18n';

interface ErrorBoundaryState {
    hasError: boolean;
    error?: Error;
    errorInfo?: React.ErrorInfo;
}

interface ErrorBoundaryProps {
    children: React.ReactNode;
    fallback?: React.ComponentType<{error?: Error; resetError: () => void}>;
}

class ChartSettingsErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return {
            hasError: true,
            error
        };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error(error, errorInfo);
        this.setState({
            error,
            errorInfo
        });
    }

    resetError = () => {
        this.setState({hasError: false, error: undefined, errorInfo: undefined});
    }

    render() {
        if (this.state.hasError) {
            const {fallback: Fallback} = this.props;
            
            if (Fallback) {
                return <Fallback error={this.state.error} resetError={this.resetError} />;
            }

            return (
                <div className="alert alert-danger" role="alert">
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <div className="font-weight-bold">{i18n.t('chart_settings_error_title.text')}</div>
                            <div>{this.state.error?.message || String(this.state.error) || i18n.t('chart_settings_unknown_error.text')}</div>
                        </div>
                        <button className="btn btn-sm btn-outline-light" onClick={this.resetError}>
                            {i18n.t('bt_try_again.text')}
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ChartSettingsErrorBoundary;
